<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ title }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.completed">
            <v-checkbox :label="$schema.completed.$schema.title" />
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.qualified">
            <v-checkbox :label="$schema.qualified.$schema.title" />
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <w-schema v-if="!$schema.qualified.$model" :model="$schema.reason">
            <v-textarea label="Uzasadnienie" />
          </w-schema>
        </v-flex>

        <v-flex v-for="(group, index) in $schema.groups.$items" :key="'group_' + index" xs12>
          <w-schema :model="group.$item.accepted">
            <v-checkbox :label="group.$item.title.$model" />
          </w-schema>

          <w-schema v-if="!group.$item.accepted.$model" :model="group.$item.reason">
            <v-textarea label="Uzasadnienie" />
          </w-schema>
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="confirmSave">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { schemaMixin, WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import Modal from '@/components/material/Modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/application_assesment.schema';

const emptyData = {
  reason: '',
  id: '',
  state: '',
  groups: [],
  qualified: false,
  completed: false
};

const groupEmptyData = {
  accepted: false,
  reason: ''
};

const messages = {
  acceptSuccess: 'Udało się zaakceptować wniosek.',
  rejectSuccess: 'Udało się odrzucić wniosek.',
  acceptError: 'Nie udało się zaakceptować wniosku.',
  rejectError: 'Nie udało się odrzucić wniosku.'
};

// @vuese
// Modal dodawania Partnera
// @group Partners
export default {
  components: { Modal, WSchema },
  mixins: [schemaMixin, notificationsMixin],
  schema,
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    // Status wniosku
    state: {
      type: String,
      required: false
    },
    // Id wniosku
    id: {
      type: Number,
      required: false
    },
    // Czy wniosek o nową kartę
    newCardApplication: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      model: { ...emptyData },
      success: false
    };
  },
  computed: {
    title() {
      return `${this.state === 'ACCEPTED' ? 'Zaakceptuj' : 'Odrzuć'} wniosek`;
    },
    ...mapState({
      confirm: state => state.modalClose.confirm,
      groups({ settings }) {
        const key = this.newCardApplication ? 'APPLICATION_NEW_GROUPS_FORM' : 'APPLICATION_EXTEND_GROUPS_FORM';
        return JSON.parse(settings.settings[key]?.value || '[]');
      }
    })
  },
  watch: {
    show(val) {
      if (val) {
        const groups = this.groups?.map(group => ({ groupId: group.groupId, title: group.admin, accepted: false }));
        this.$schema.groups.$setData(groups);
        this.$schema.state.$setData(this.state);
        this.$schema.id.$setData(this.id);
      }
    },
    confirm(val) {
      if (val) {
        if (this.success) {
          this.save();
        } else {
          this.closeModal();
        }
        this.$store.dispatch('resetConfirmState');
        this.success = false;
      }
    }
  },
  methods: {
    // @vuese
    // Potwierdzenie zamknięcia formularza w przypadku zmian
    close() {
      if (this.$schema.$dirtyList().length !== 0) {
        this.$store.dispatch('showConfirmDialog');
      } else {
        this.closeModal();
      }
    },
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    closeModal() {
      // Zamyka modal
      this.$emit('close');
      this.clearForm();
    },
    // @vuese
    // Metoda czyści pola formularza
    clearForm() {
      this.$schema.$setData({ ...emptyData });
      this.$schema.groups.$items.forEach(({ $item }) => {
        $item.$setData(groupEmptyData);
      });
      this.$schema.$reset();
    },
    // @vuese
    // Dodatkowy modal potwierdzający akceptację
    confirmSave() {
      if (this.$schema.$validateAll().length) {
        return this.notifyError('Błędnie wypełniony formularz');
      }
      this.success = true;
      this.$store.dispatch('showConfirmDialog', {
        title: this.state === 'ACCEPTED' ? 'Potwierdź akceptację wniosku' : 'Potwierdź odrzucenie wniosku',
        text:
          this.state === 'ACCEPTED'
            ? 'Po zaakceptowaniu wniosku karta elektroniczna zostanie aktywowana. Nie będzie możliwości zmiany statusu wniosku. Czy na pewno chcesz go zaakceptować?'
            : 'Po odrzuceniu wniosku Mieszkaniec będzie musiał złożyć nowy, aby wystąpić o kartę. Czy na pewno chcesz go odrzucić?',
        cancelText: 'Anuluj',
        confirmText: 'Zatwierdź'
      });
    },
    // @vuese
    // Metoda zapisuje Partnera
    save() {
      this.$store
        .dispatch('application/update', this.$schema.$getData())
        .then(() => {
          if (this.state === 'ACCEPTED') {
            this.notifySuccess(messages.acceptSuccess);
          } else {
            this.notifySuccess(messages.rejectSuccess);
          }
          this.$store.dispatch('application/get');
          this.closeModal();
        })
        .catch(() => {
          if (this.state === 'ACCEPTED') {
            this.notifyError(messages.acceptError);
          } else {
            this.notifyError(messages.rejectError);
          }
        });
    }
  }
};
</script>
